import { useState } from 'react';
import PropTypes from 'prop-types';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@material-ui/core';
import CreateSnapshotModal from './CreateSnapshotModal';

SnapshotButton.propTypes = {
  rackDetails: PropTypes.object,
  variant: PropTypes.string,
  color: PropTypes.string,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
    PropTypes.func,
    PropTypes.object
  ]),
  disabled: PropTypes.bool
};

SnapshotButton.defaultProps = {
  rackDetails: {},
  variant: 'contained',
  color: 'primary'
};

export default function SnapshotButton({ variant, color, sx = [], disabled, rackDetails }) {
  const [snapshotModalOpen, setSnapshotModalOpen] = useState(false);

  const openModal = () => {
    setSnapshotModalOpen(true);
  };

  const closeModal = () => {
    setSnapshotModalOpen(false);
  };
  return (
    <>
      <Button
        data-testid="snapshot-button"
        onClick={openModal}
        variant={variant}
        sx={{ ...sx }}
        disabled={disabled}
        startIcon={<ContentCopyIcon />}
        color={color}
      >
        Snapshot
      </Button>

      <CreateSnapshotModal
        isOpen={snapshotModalOpen}
        closeHandler={closeModal}
        rackName={rackDetails.name}
        identity={rackDetails.provisioner_identity}
      />
    </>
  );
}
